/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(array, value) {
  var low = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var high = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : array.length - 1;
  var mid;
  var midValue;
  var midNextIndex;
  var midNextValue;
  while (low <= high) {
    mid = low + (high - low >> 1);
    midValue = array[mid];
    midNextIndex = mid + 1;
    midNextValue = array[midNextIndex];
    if (midValue <= value) {
      if (midNextValue === undefined || midNextValue > value) {
        return mid;
      }
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }
  return -1;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/utils/searchClosestSmallerValue.js
// module id = 802
// module chunks = 0